import {
  mapState,
  mapMutations
} from "vuex";
import Keypad from "../components/modal/keypad";
import QRpad from "../components/modal/qrauthen";
import Gate from "../components/modal/gate";
import keypadgate from "../components/modal/keypadgate";
import MemberPage from "../components/modal/memberauthen";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import api from "../service/services";
import $ from "jquery";
import swal from "sweetalert2";
// var client = require('emitter-io').connect({
//   host: '35.240.146.79',
//   port: 8888
// })

export default {
  components: {
    Keypad,
    QRpad,
    Loading,
    Gate,
    keypadgate,
    MemberPage
  },
  data() {
    return {
      apiURL:sessionStorage.apiURL,
      set_mainpage:'',
      showstatus: false,
      timescreen: '',
      background: localStorage.background,
      logo_url: localStorage.logo_url,
      shop_title: localStorage.shop_title,
      lconfig: '',
      title: "เมนู",
      menu_active: 0,
      menu_data: [{
        menu_id: 3,
        menu_act: 0,
        image_name: "logo",
        image_path: require("../assets/gate.png"),
        goto: '',
        title_name: [{
          name_id: 0,
          name: "SCAN QRCODE"
        },
        {
          name_id: 1,
          name: "สแกนคิวอาร์โค้ด"
        },
        {
          name_id: 2,
          name: "入口"
        }
        ],
      },
      {
        menu_id: 2,
        menu_act: 1,
        image_name: "shopping",
        image_path: require("../assets/shopping.png"),
        title_name: [{
          name_id: 0,
          name: "Shopping"
        },
        {
          name_id: 1,
          name: "ซื้อสินค้า"
        },
        {
          name_id: 2,
          name: "購物"
        }
        ]
      },
      {
        menu_id: 1,
        menu_act: 1,
        image_name: "economy",
        image_path: require("../assets/economy.png"),
        title_name: [{
          name_id: 0,
          name: "Deposit"
        },
        {
          name_id: 1,
          name: "เติมเงิน"
        },
        {
          name_id: 2,
          name: "存款"
        }
        ]
      }
      // {
      //   menu_id: 6,
      //   menu_act: 1,
      //   image_name: "logo",
      //   image_path: require("../assets/pay9.png"),
      //   goto: 'Openapp',
      //   title_name: [{
      //     name_id: 0,
      //     name: "Member Shop"
      //   },
      //   {
      //     name_id: 1,
      //     name: "สำหรับสมาชิก"
      //   },
      //   {
      //     name_id: 2,
      //     name: "對於會員"
      //   }
      //   ]
      // }
      ],
      items: [],
      countloop: 0
    };
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AmountPayment",
      "AuthenType",
      "isconnect_emitterpay",
      "create_at",
      "shift_status",
      "mqttKey",
      "config",
      "ui_mode",
      "StatusHardware",
      "wsStatus"
    ]),
    ...mapMutations(["onMessageWs","clearState"]),

  },
  methods: {
    screenServer () {
      this.timescreen = setTimeout(() => {
          this.$router.push({ name: 'Screen' })
      }, 300000)
    },
    setMenu(value) {
      clearTimeout(this.timescreen)
      this.Soundclick();
      this.setTitle();
      this.$store.state.SaleID = value;
      this.$store.state.SaleType = 1;
      this.$store.state.acl = 0
      if (value == 1) {
        this.$router.push({
          name: "WalletSigin"
        });
      } else if (value == 2) {
        this.$router.push({
          name: "shopping"
        });
      } else if (value == 3) {
        this.$store.state.AuthenType = 3
        $("#Modal").modal("show");
        return
      } else if (value == 6) {
        this.$store.state.SaleID = 2
        this.$store.state.AuthenType = 5
        $("#Modal").modal("show");
        return
      }
      // else if (value == 7) {
      //   var testdata = "{\"note\":0, \"note2\":0, \"coin\":225}"
      //   var ret = JSON.parse(testdata.replace('"\"',''))
      //   var yuyu = {}
      //   yuyu.note = ret.note
      //   yuyu.note2 = ret.note2
      //   yuyu.coin = ret.coin
      //   console.log(yuyu)
      //   return
      // }
    }, modeSwitch(mode) {
      api.switchMode(mode)
      if (mode == 1) {
        this.$store.state.ui_mode = 1
      }
      if (mode == 0) {
        this.$store.state.ui_mode = 0
      }
    },
    setLang(value) {
      this.$store.state.lang = value
      this.setTitle()
      this.getQuickPay()
    },
    setTitle() {
      switch (this.lang) {
        case 0:
          this.title = "Menu";
          break;
        case 1:
          this.title = "เมนู";
          break;
        case 2:
          this.title = "菜单";
      }
    },
    getUUID() {
      try {
        this.$socket.sendObj({
          command: "vending_uuid"
        })
        if (this.UUID != null) {
          console.log("haveUUID")
        }
      } catch (e) {
        // alert('cannot get UUID ERROR = ' + e);
        this.reload()
        // this.getUUID()
        // this.$store.state.isLoading = true;
        sessionStorage.clear()
      }
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        // this.$store.state.wsStatus = true
        this.$store.commit("onMessageWs", JSON.parse(skResult.data));
      };
    },
    getToken() {
      api.getToken({
        vending_uuid: this.UUID
        // vending_uuid: '6b12ab295135424bbf2dc9a4740685e0'
        // vending_uuid: '56819d086ae74798984b5b186a081234'
      },
        result => {
          console.log(result)
          if (result.result == "success") {
            // อ่าจจะต้องเก็บไว้ใน session storage
            sessionStorage.accessToken = result.token;
            this.$store.state.accessToken = result.token;
            sessionStorage.mqttKey = result.mqtt_key;
            this.$store.state.mqttKey = result.mqtt_key;
            this.GetConfigSetting()
            if (this.$store.state.shift_uuid == "") {
              this.getShiftStatus();
            } else {
              // this.$store.state.isLoading = false;
            }
            this.CheckStatusPartner();
          } else {
            alert("get Token = " + JSON.stringify(result));
            sessionStorage.clear()
            this.getUUID()
          }
        },
        error => {
          alert(JSON.stringify(error));
          sessionStorage.clear()
          this.getUUID()
        }
      );
    },
    getShiftStatus() {
      const header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
        }
      };
      console.warn('shift header = ' + JSON.stringify(header))
      // this.$store.state.isLoading = true;
      api.shitfStatus(
        header,
        result => {
          this.$store.state.shift_uuid = result.shift_uuid;
          this.$store.state.open_at = result.open_at;
          this.$store.state.shift_status = result.shift_status;
          // this.$store.state.isLoading = false;
          console.warn("getShift = " + this.$store.state.shift_uuid);
        },
        error => {
          swal
            .fire({
              title: "Check Shift Status Error",
              text: error,
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reconnect !"
            })
            .then(result => {
              if (result.value) {
                this.getShiftStatus();
              } else {
                this.getShiftStatus();
              }
            });
          // this.$store.state.isLoading = false;
        }
      );
    },
    authen() {
      clearTimeout(this.timescreen)
      this.$store.state.AuthenType = 1;
      this.$socket.sendObj({
        Device: "host",
        type: "request",
        command: "qr"
      });
      $("#Modal").modal("show");
    },
    close_qr() {
      this.$store.state.AuthenType = 0;
      // this.$socket.sendObj({
      //   Device: "host",
      //   type: "request",
      //   command: "qr_authentication"
      // });
    },
    getQuickPay() {
      // this.$store.state.isLoading = true
      const header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };
      console.log('UUID : ' + this.UUID)
      api.quick_pay(header,
        result => {
          this.$store.state.isLoading = false
          console.log(result.data)
          if (result.result === 'success') {
            switch (this.lang) {
              case 0:
                if (result.data[1].items != null) {
                  this.items = result.data[1].items
                }
                break
              case 1:
                if (result.data[0].items != null) {
                  this.items = result.data[0].items
                }
                break
              case 2:
                if (result.data[2].items != null) {
                  this.items = result.data[2].items
                }
                break
            }
          }
        },
        error => {
          alert(JSON.stringify(error))
          // this.$store.state.isLoading = true
        }
      );
    },
    message_received(msg_pay) {
      console.log(JSON.stringify(msg_pay))
      const obj = {
        ref_number: msg_pay.ref_number,
        status: "MESSAGE_RECEIVED"
      }
      const header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };
      console.log(header)
      console.log(obj)
      api.getReceiveC9(obj, header,
        result => {
          console.log(result)
          if (this.$route.name == 'Main') {
            if (msg_pay.customer_code) {
              swal.fire({
                title: 'Payment id ' + msg_pay.customer_code,
                text: "รหัส: " + msg_pay.customer_name + ' ชื่อลูกค้า: ' + msg_pay.customer_name + ' ราคา: ' + msg_pay.amount + ' THB',
                type: 'warning',
                animation: true,
                showCancelButton: true,
                cancelButtonText: 'ยกเลิก',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง'
              }).then((result) => {
                if (result.value) {
                  this.$store.state.SaleID = 5;
                  this.$store.state.SaleType = 1;
                  this.$store.state.AmountPayment = 0
                  this.$store.state.total = msg_pay.amount
                  this.$store.state.ref_number = msg_pay.ref_number
                  this.$store.state.acl = 0
                  this.$store.state.sale_subs = [{
                    line: 1,
                    item_id: '1000589',
                    item_name: msg_pay.customer_name,
                    qty: 1,
                    price_id: 1,
                    price_name: '',
                    price: parseFloat(msg_pay.amount),
                    currency: "THB",
                    image: require('../assets/select_c9.png')
                  }]
                  console.log(JSON.stringify(this.$store.state.sale_subs))
                  this.$router.push({
                    name: "Type"
                  });
                } else {

                }
              })
            }
          }
        }, error => {
          alert(JSON.stringify(error))
        }
      )
    },
    connect_emitter_payquick() {
      // this.$store.state.isLoading = true;
      if (this.$store.state.isconnect_emitterpay == 0) {
        try {
          console.log(this.$store.state.isconnect_emitterpay)
          this.$store.state.isconnect_emitterpay = 1
          console.log('mqttKeykey = ' + this.$store.state.mqttKey)
          console.log('accessTokenchannel = ', "payment/" + this.$store.state.accessToken + "/")
          client.subscribe({
            // key: "vEmN6D_S7SaVKx6lTT1dAEJCNN__2U0c",
            // channel: "payment/2f570ceb279847a19fd570b9a6208852/"
            key: this.$store.state.mqttKey,
            channel: "payment/" + this.$store.state.accessToken + "/"
          });
          client.on('message', (msg) => {
            var msg_pay = msg.asObject()
            this.message_received(msg_pay)
          })
          this.$store.state.isLoading = false;
        } catch (e) {
          setTimeout(() => {
            location.reload()
          }, 3000)
        }
        // this.$store.state.isLoading = false;
      }
    },
    paymentQuickpay(obj) {
      this.$store.state.SaleID = 4;
      this.$store.state.SaleType = 1;
      this.$store.state.AmountPayment = 0
      this.$store.state.total = obj.price
      this.$store.state.acl = obj.acl
      this.$store.state.sale_subs = [{
        line: 1,
        item_id: obj.id.toString(),
        item_name: obj.name,
        qty: 1,
        price_id: 1,
        price_name: obj.item_name,
        price: parseFloat(obj.price),
        currency: "THB",
        image: obj.image
      }]
      console.log(JSON.stringify(this.$store.state.sale_subs))
      this.sayLang(obj.name)
      this.$router.push({
        name: "Type"
      });
    },
    stopinterval() {
      clearInterval(this.$store.state.downloadTimer)
      clearInterval(this.$store.state.intervalqrcode)
    },
    GetConfigSetting() {
      const header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };
      api.configClient(
        header,
        result => {
          console.log(result)
          if (result.result == "success") {
            this.$store.state.config = result.client
            // this.logo_url = localStorage.logo_url
            // this.shop_title = result.client.client.shop_title
            // this.background = localStorage.background
            localStorage.logo_url = result.client.client.logo_url
            localStorage.shop_title = result.client.client.shop_title
            localStorage.background = result.client.client.background
            console.log('Get Config  = ' + this.$store.state.config)
            this.menu_data[0].menu_act = result.client.menu.door
            this.menu_data[1].menu_act = result.client.menu.shopping
            this.menu_data[2].menu_act = result.client.menu.deposit
            this.menu_data[3].menu_act = result.client.menu.member
          }
        },
        error => {
          console.log(JSON.stringify(error))
        }
      )
    },
    CheckStatusPartner() {
      const header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": '2f570ceb279847a19fd570b9a6208850'
        }
      };
      api.CheckStatusPartner(
        header,
        result => {
          console.log(result)
          if (result.response == "success") {
            console.log("CheckStatusPartner : Success")
          } else {
            swal.fire({
              title: 'แจ้งเตือน',
              text: "ระบบมีปัญหากรุณาติดต่อเจ้าหน้าที่",
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Reconnect !",
              timer: 30000
            }).then(result => {
                if (result.value) {
                  this.$router.push({
                    name: "Main"
                  });
                }
                this.reload()
            });
          }
        },
        error => {
          console.log(JSON.stringify(error))
        }
      )
    }
  },
  created(){
    // this.connect_ws()
    // this.screenServer()
    clearInterval(this.$store.state.scan_barcode)
    this.websocket_onmessage()
    this.$store.commit('clearState')
    api.switchMode(this.$store.state.ui_mode);
    this.getUUID();
  },
  mounted() {
    console.log("start")
    this.set_mainpage = setInterval(() => {
    // this.getUUID();
    console.log("set_main")
    this.$store.state.isLoading = true
    if (this.countloop == 5) {
      location.reload()
    }
    this.countloop++
    if (this.UUID != '' && this.UUID != null) {
    this.$store.state.isLoading = false
    clearInterval(this.set_mainpage)
    this.$socket.sendObj({
      Device: 'host',
      type: 'request',
      command: 'status'
    })
    if (!this.accessToken) {
      this.$store.state.isLoading = true;
    }

    clearInterval(this.$store.state.setInter)
    this.$store.commit('clearPulling')
    setTimeout(() => {
      this.getToken()
      $("#Modal").on(
        "hidden.bs.modal",
        function () {
          clearInterval(this.$store.state.downloadTimer)
          clearInterval(this.$store.state.intervalqrcode)
          clearInterval(this.$store.state.stepauthmember)
          // this.screenServer()
          this.close_qr();
        }.bind(this)
      );
      $("body").on("hidden.bs.modal", ".modal", function () {
        $(this).removeData("bs.modal");
      });
      this.$store.state.IDWallet = null;
      this.setLang(1);
      this.$store.state.accessToken = sessionStorage.accessToken;

      // this.$store.state.mqttKey = sessionStorage.mqttKey;
      // console.log('mqttKey = ' + this.$store.state.mqttKey)
      // console.log('token = ' + this.$store.state.accessToken)
      setTimeout(() => {
        if (this.UUID != null) {
          if (!this.$store.state.accessToken || this.$store.state.accessToken === 'undefined') {
            this.getToken();
          } else {
            this.getShiftStatus();
            this.getQuickPay()
          }
        } else {
          this.getUUID();
        }
      }, 1000);
      // this.connect_emitter_payquick()
      this.setTitle();
      // this.lconfig = setInterval(() => {
      //   if (this.$store.state.accessToken || this.$store.state.accessToken != 'undefined') {
      //     console.log('tag')
      //     this.GetConfigSetting()
      //     clearInterval(this.lconfig)
      //   }
      // }, 1000);
      this.$store.state.setInter = setInterval(() => {
        this.checkWebsocket();
        if (this.UUID != null) {
          if (!this.$store.state.accessToken || this.$store.state.accessToken === 'undefined') {
            this.getToken();
          } else {
            this.getShiftStatus();
            this.CheckStatusPartner();
          }
        } else {
          this.getUUID();
        }
        this.checkCloseWebsocket();
      }, 30000);

      console.log(this.$store.state.config)
      // console.clear()
    }, 2100)}
  }, 1000)
  // setTimeout(() => {
  //   this.$socket.sendObj({
  //     command: 'receive_close'
  //   })
  // }, 3000)
  }
}



// WEBPACK FOOTER //
// ./src/js/main.js